<template>
  <div>
    <div style="display: flex;justify-content: flex-end">
      <slot name="header"></slot>
    </div>

    <div class="formDiv">
      <a-form :form="trackForm" layout="vertical">
        <div style="padding: 20px 20px 0 20px;background: rgba(248,249,251,0.62);">
          <a-row :gutter="20">
            <!-- 公司名称 -->
            <a-col :span="16">
              <a-form-item class="required" :label="$t('track.trackModal.companyLabel')">
                <a-select :placeholder="$t('track.trackModal.companyTip')"
                          showSearch
                          :defaultActiveFirstOption='false'
                          :showArrow='false'
                          :filterOption='false'
                          @search='handleSearch'
                          :disabled='leaseVO'
                          @change='customerIdChange'
                          :notFoundContent='null'  v-decorator='decorators.customerId'>
                  <a-icon slot='suffixIcon' type='caret-down' />
                  <div slot='dropdownRender' slot-scope='menu'>
                    <v-nodes :vnodes='menu' />
                    <a-divider style='margin: 0;' />
                    <div class='addCustomerBtn' @click='openAddCustomerModal'>
                      <pt-icon type='icon-zengjia' class='addIcon'></pt-icon>
                      <div style='font-size: 12px;color: #ffffff;margin-left:4px;'>
                        {{ $t('track.trackModal.addCustomer') }}
                      </div>
                    </div>
                  </div>
                  <a-select-option v-for='d in customerList' :key='d.id' :value='d.id'>
                    <div style='display:flex;'>
                      <div style='flex:1;' class='invisible-item'>
                        {{ d.companyName }}
                      </div>
                      <div>
                        {{ d.companySortNameCn }}
                      </div>
                    </div>
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 公司简称 -->
            <a-col :span="8">
              <a-form-item class="required" :label="$t('customer.customerModal.companyNameCNLabel')">
                <a-input disabled v-model="companyNameCNLabel" :placeholder="$t('customer.customerModal.companyNameCNTip_2')"></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="20">

            <!-- 需求类型 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.tableLabel.type')">
                <pt-select :placeholder="$t('track.trackModal.choiceTrackType')" v-decorator="decorators.pursuitsType" :allowClear='false' >
                  <a-select-option v-for='d in trackTypes' :key='d.wordKey' :value='d.wordKey'>{{ d.wordValue }}
                  </a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>


            <!-- 需求面积 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.trackModal.needAreaLabel')">
                <a-input-group compact>
                  <pt-input-number style='width:70%;' v-decorator='decorators.demandArea'
                                   :placeholder="$t('track.trackModal.needAreaTip')"
                                   :min='0'
                                   :blackhillsYellow='true'
                                   :max='9999999999' :precision='2'></pt-input-number>
                  <pt-unit-select style='width: 30%;' type='area' v-decorator='decorators.demandAreaUnit'
                                  disabled></pt-unit-select>
                </a-input-group>
              </a-form-item>
            </a-col>

            <!-- 预计启动时间 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.trackModal.expectStartTime')" >
                <pt-month-picker style="width:100%;" v-decorator="decorators.expectStartDate" :placeholder="$t('track.trackModal.expectStartTimeTip')"
                                 :blackhillsYellow="true"></pt-month-picker>
              </a-form-item>
            </a-col>

            <!-- 追踪类型 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.trackModal.trackType')">
                <pt-select :placeholder="$t('track.trackModal.propertyTypeTip')" v-decorator='decorators.trackingType'
                           :allowClear='false'>
                  <a-select-option v-for='d in trackingTypes' :key='d.wordKey' :value='d.wordKey'>{{ d.wordValue }}
                  </a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>

            <!-- 物业类型 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.trackModal.propertyTypeLabel')">
                <pt-select :placeholder="$t('track.trackModal.propertyTypeTip')" v-decorator='decorators.propertyType'
                           :allowClear='false'>
                  <a-select-option v-for='d in propertyTypes' :key='d.wordKey' :value='d.wordKey'>{{ d.wordValue }}
                  </a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <!-- 备注 -->
            <a-col :span="24">
              <a-form-item :label="$t('track.trackModal.remarksLabel')">
                <a-textarea  v-decorator="decorators.remarks"
                             :rows="3"
                             :placeholder="$t('track.trackModal.remarksTip')"
                             style="background-color:#FFFFFF !important;"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </div>
        <!-- 追踪 -->
        <div style="display: flex;flex-direction: row;align-items: center;margin-top: 15px">
          <div style="background-color: #FABE00;width: 12px;height: 12px;border-radius: 50%;"></div>
          <div style="margin-left: 10px;font-size: 14px;font-weight: 600">{{$t('track.trackModal.track')}}</div>
        </div>
        <div style="padding: 20px 20px 0 20px;background: rgba(248,249,251,0.62);margin-top: 5px">
          <a-row :gutter="20">
            <!-- 需求状态 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.tableLabel.demandStatus')" class="required">
                <pt-select style="color: #E9B100" :placeholder="$t('track.queryParams.placeholder.demandStatus')" v-decorator="decorators.demandStatus" :allowClear="false">
                  <a-select-option  v-for="(item,index) in $t('track.demandStatus') " :key="index" :value="item.value">{{item.name}}</a-select-option>
                </pt-select>
              </a-form-item>
            </a-col>
            <!-- 竞争对手 -->
            <a-col :span="16">
              <a-form-item :label="$t('track.trackModal.opponentLabel')">
                <ptSelect mode='multiple' v-model='colleagueList' :placeholder="$t('track.trackModal.opponentTip')"
                          :maxTagCount=3 :maxTagTextLength='6'>
                  <a-select-option v-for='c in competitors' :key='c.id' :value='c.id' :disabled='!c.selectable'>
                    <div style='display:flex;'>
                      <div style='flex:1;' class='invisible-item'>
                        {{ c.companyName }}
                      </div>
                      <div>
                        {{ c.companySortNameCn }}
                      </div>
                    </div>
                  </a-select-option>
                </ptSelect>
              </a-form-item>
            </a-col>
            <!-- 转交易可能性 -->
            <a-col :span="8">
              <a-form-item :label="$t('track.tableLabel.transfer')">
                <div class="slider-wrapper">
                  <pt-slider :edit-mode="!disabled"  :old-step="currProjectPossible" @changeStep="changeBrokerageRatio" ref="possibleSliderRef"
                             :blackhills-yellow="true" v-decorator="decorators.transfer"></pt-slider>
                </div>
              </a-form-item>
            </a-col>
            <!-- 追踪人员 -->
            <a-col :span="16">
              <a-form-item :label="$t('track.tableLabel.follower')" class="required">
                <pt-user-select
                  :maxTagTextLength="3"
                  v-decorator="decorators.trackPersonDOS" :placeholder="$t('track.queryParams.placeholder.follower')"  style="width: 150px" mode="multiple" :maxTagCount=3></pt-user-select>
              </a-form-item>
            </a-col>
            <!-- 目标区域 -->
            <a-col :span="24" class="targetClass">
              <a-form-item :label="$t('deal.addDeal.dealDetails.targetArea')">
                <pt-multi-cascader
                  v-decorator="decorators.targetArea"
                  :styleObj="{width: '100%'}"
                  size="small"
                  :options="cityDatas"
                  :props="{multiple: true}"
                  collapse-tags
                ></pt-multi-cascader>
              </a-form-item>
            </a-col>
            <!-- 目标大厦 -->
            <a-col :span="24" >
              <a-form-item  :label="$t('track.tableLabel.targetBuilding')">
                <div @click="openSelectMansion">
                  <pt-select v-decorator="decorators.targetBuilding"
                             :placeholder="$t('track.queryParams.placeholder.targetBuilding')"
                             :defaultActiveFirstOption="false"
                             :showArrow="false"
                             :filterOption="false"
                             :maxTagCount=3 :maxTagTextLength="13"
                             :notFoundContent="null"
                             mode="multiple"
                             @change="mansionChange"
                  >
                    <a-select-option v-for="m in mansionOptions" :key="m.id" :value="m.id">{{ m.name }}
                    </a-select-option>
                  </pt-select>
                </div>
              </a-form-item>
            </a-col>
          </a-row>
        </div>


      </a-form>
    </div>

    <pt-modal :title="customerModalTitle" :visible="customerModalVisible"
              @ok="saveCustomer" @cancel="cancelAddCustomer" :width="800"
    >
      <div slot='content'>
        <add-customer ref='customerModel' v-model='customerModalTitle' @saveSuccess='saveSuccess'></add-customer>
      </div>
    </pt-modal>

    <pt-modal :title="$t('proprietor.selectMansionModal.title')" :visible="selectModel.visable"
              :loading="selectModel.loading"
              @ok="submitEvent" @cancel="cancelEvent" :width="800">
      <div slot="content">
        <select-mansion :count-num=3 :radio="false" :mansionList="mansionList" ref="selectMansion" @confirmSelect="confirmSelect"></select-mansion>
      </div>
    </pt-modal>

    <dealPursuitsTable :customerId='getCustomerId' ref='dealPursuitsTableRef'></dealPursuitsTable>
  </div>
</template>

<script>
import customerApi from '@/api/mine/customer'
import dealPursuitsTable from '../../deal/dealPursuitsTable'
import colleagueApi from '@/api/database/colleague'
import { findCascadingData } from '@/api/sys/datadict'
import addCustomer from '../../../database/customer/module/addCustomer'
import selectMansion from '../../../database/proprietor/module/selectMansion'
import pursuitsLinkmanApi from '@/api/mine/pursuitsLinkman'
import pursuitsApi from '@/api/mine/pursuit'




export default {
  name: 'editIssue',
  components: {
    dealPursuitsTable,addCustomer,selectMansion,
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes,
    },
  },
  props: {
    oldValue:{
      type:Object,
      default:false,
    },
      leaseVO:{}
  },
  data() {
    return {
      customerList:[],
      selectModel: {
        visable: false,
        loading: false
      },
      contactVisible:false,
      trackTypes:[],
      propertyTypes:[],
      linkManDOs:[],
      customerModalVisible:false,
      mansionList:[],
      customerModalTitle:'',
      trackingTypes:[],
      contactForms:[],
      mansionOptions:[],
      currProjectPossible:0,
      brokerageRatio:0,
      colleagueList:[], //竞争对手
      competitors:[],
      cityDatas: [],
      getCustomerId:null,
      companyNameCNLabel:null,
      contactForm:this.$form.createForm(this,{}),
      trackForm:this.$form.createForm(this,{}),
      decorators:{
        customerId:['customerId',{rules:[{required:true,message:this.$t('track.trackModal.companyTip')}]}],//公司名称
        pursuitsType:['pursuitsType',{rules:[],initialValue:null}],//需求烈性
        demandArea:['demandArea',{rules:[],initialValue:null}],//面积
        demandAreaUnit:['demandAreaUnit',{rules:[],initialValue:null}],//单位
        expectStartDate:['expectStartDate',{rules:[],initialValue:undefined}],//预计启动时间
        propertyType:['propertyType',{rules:[],initialValue:null}],//物业类型
        trackingType:['trackingType',{rules:[],initialValue:null}],//追踪类型
        remarks:['remarks',{rules:[{max: 256, message: this.$t('track.trackModal.remarkLengthTip'), trigger: 'blur'},],initialValue:null}],//备注
        demandStatus:['demandStatus',{rules:[{required:true,message:this.$t('track.queryParams.placeholder.demandStatus')}]}], //需求状态
        transfer:['transfer',{rules:[],initialValue:undefined}],//转交易
        trackPersonDOS:['trackPersonDOS',{rules:[{required:true,message:this.$t('track.queryParams.placeholder.follower')}]}],//追踪人员
        targetArea:['targetArea',{rules:[],initialValue:undefined}],//目标区域
        targetBuilding:['targetBuilding',{rules:[],initialValue:undefined}],//目标大厦




      }
    }
  },
  mounted() {

    this.init();

  },
  methods: {
    init(){
      this.initTrackingType()
      this.handleSearchById(this.oldValue.customerId)
      this.initPropertyTypes()
      this.initTrackType()
      this.initCompetitors()
      this.queryCityDataByCity()
      this.toEditMode();

      console.log('this.trackForm.getFieldsValue()',this.trackForm.getFieldsValue())


    },



    toEditMode(){
      console.log('this.oldValue',this.oldValue)
      let defaultValue = JSON.parse(JSON.stringify(this.oldValue).replace(/\"~\"/g,null).replace(/\"0\"/g, null))
      console.log('defaultValue',defaultValue)

      this.colleagueList = this.oldValue.colleagueDOS != null ? this.oldValue.colleagueDOS.map(e=>{return e.id}) : []

      if(defaultValue.targetArea != '~'){
        defaultValue.targetArea = JSON.parse(defaultValue.targetArea)
      }else{
        defaultValue.targetArea = null
      }
      this.mansionList = defaultValue.buildingList;
      this.mansionOptions = defaultValue.buildingList;
      this.currProjectPossible = defaultValue.transfer;

      if(defaultValue.trackingType == 0 ){
        defaultValue.trackingType = '1'
      }else{
        defaultValue.trackingType = defaultValue.trackingType+''
      }

      if(defaultValue.demandStatus == 0 ){
        defaultValue.demandStatus = undefined
      }

      // let trackPersonDOS = []
      // if(defaultValue.trackPersonDOS != null && defaultValue.trackPersonDOS.length>0){
      //   defaultValue.trackPersonDOS.forEach(data => {
      //     trackPersonDOS.push(data)
      //   })
      //   defaultValue.trackPersonDOS = trackPersonDOS
      // }

      defaultValue.expectStartDate = this.oldValue.expectStartDate != '~' ? this.$moment(defaultValue.expectStartDate) : undefined
      this.companyNameCNLabel = defaultValue.companyShortName //公司简称
      this.trackForm.setFieldsValue(defaultValue)



    },

    handleSearchById(id) {
      console.log("handleSearchById",id)
      let this_ = this
      customerApi.selectOne(id).then(res => {
        this_.trackForm.setFieldsValue({
          customerId: res.data.id,
          customerName: res.data.companyName,
        })
        this.companyNameShort = res.data.companySortNameCn;
        console.log(this_.trackForm.getFieldsValue())
        // console.log("this_.trackForm.",this_.trackForm.getFieldsValue())
        this_.customerList.push(res.data)
        console.log(this_.customerList)
      })
    },

    handleSearch(customerName){
      setTimeout(()=>{
        let this_ = this
        customerApi.queryByName({name: customerName}).then(res => {
          this_.customerList = res.data
        })
      },300);
    },
    customerIdChange(value){
      this.getCustomerId = value
      let customerDO = this.customerList.find(e=>{ return e.id == value })
      this.companyNameCNLabel = customerDO.companySortNameCn
      this.$refs.dealPursuitsTableRef.queryDealPursuitsList(this.getCustomerId,1)
    },
    //获取需求类型
    initTrackType(){
      let trackTypes = this.$t('track.trackTypeMy')
      for(var p in trackTypes){
        this.trackTypes.push({wordKey:p,wordValue:trackTypes['' + p]})
        this.trackForm.setFieldsValue({pursuitsType:'新设立'})
      }
    },
    saveCustomer(){
      this.$refs.customerModel.submit();
    },
    cancelAddCustomer(){
      this.customerModalVisible = false;
    },
    openAddCustomerModal(){
      this.customerModalVisible = true;
    },
    //获取物业类型
    initPropertyTypes(){
      let propertyTypes = this.$t('deal.propertyTypes')
      for(var p in propertyTypes){
        this.propertyTypes.push({wordKey:p,wordValue:propertyTypes['' + p]})
        this.trackForm.setFieldsValue({propertyType:'写字楼'})
      }
    },
    //追踪类型
    initTrackingType(){
      let trackingTypes = this.$t('track.trackingType')
      for(var p in trackingTypes){
        this.trackingTypes.push({wordKey:p,wordValue:trackingTypes['' + p]})
        this.trackForm.setFieldsValue({trackingType:'1'})
      }



    },

    //获取竞争对手
    initCompetitors(){
      colleagueApi.selectAll().then(res=>{
        if(res.code == 1){
          this.competitors = res.data.records
        }
      })
    },
    changeBrokerageRatio(){
      this.trackForm.setFieldsValue({transfer: this.$refs.possibleSliderRef.currStep})
    },
    //根据城市查询区域位置
    queryCityDataByCity() {
      findCascadingData('system.mansion_set.address', 4, undefined).then(res => {
        this.cityDatas = res.data
      })
    },

    mansionChange(value) {
      console.log('mansionList', this.mansionList)
      console.log('value', value)
      for (var i = 0; i < this.mansionList.length; i++) {
        let indexOf = value.indexOf(this.mansionList[i].id)
        if (indexOf == -1) {
          this.mansionList.splice(i, 1)
          i--
        }
      }
      this.fillMansionOptions()
    },
    confirmSelect(mansionList) {
      this.mansionList = mansionList
      this.mansionOptions = []
      let mansionIds = []
      this.mansionList.forEach(item => {
        this.mansionOptions.push({ id: item.id, name: item.name })
        mansionIds.push(item.id)
      })
      this.$nextTick(() => {
        this.trackForm.setFieldsValue({ targetBuilding: mansionIds })
      })
      this.cancelEvent()
    },
    openSelectMansion() {
      this.selectModel.visable = true
    },
    submitEvent() {
      this.$refs.selectMansion.confirmSelect()
    },
    cancelEvent() {
      this.selectModel.visable = false
    },
    saveSuccess(id,name, customer){
      this.customerList = [];
      var customerDO = {
        companyName:name,
        id:id,
        companySortNameCn: customer.companySortNameCn
      }
      this.getCustomerId = id
      this.companyNameCNLabel = customer.companySortNameCn
      this.trackForm.setFieldsValue({
        customerId: id,
      })
      this.customerList.push(customerDO);
      this.customerModalVisible = false;
    },

    toggleContact(visible){
      this.contactVisible = visible;
      if(visible){
        this.addContactRow()
      }else{
        this.contactForms = []
      }
    },

    submitPursuit(){
      let validatePass = true
      this.trackForm.validateFields(err=>{
        if(err){
          validatePass = false
        }
      })
      if(!validatePass){
        this.$emit('error')
        return
      }


      let pursuitVO = this.trackForm.getFieldsValue()
      // pursuitVO.leaseLeaseInfoVOS = this.leaseInfoDOS
      pursuitVO.leaseLeaseInfoTypeVOS = this.leaseInfoDOS
      pursuitVO.colleagueDOS = this.colleagueList.map(e=>{
        return {id: e}
      })
      pursuitVO.id = this.oldValue.id
      pursuitVO.depId = this.oldValue.depId
      console.log("pursuitVO",pursuitVO)
      pursuitsApi.updatePursuitsDetails(pursuitVO).then(res=>{
        if(res.code == 1){
          this.$message.success("保存成功")
          this.$emit('saveSuccess')
        }else{
          // this.$message.error(res.message)
          this.$emit('error')
        }
      })
    },





  }
}
</script>

<style scoped lang="less">
@import '../../../../core/diy.less';
.blackhillsYellow{
  color: @blackhills-yellow;
}
.targetClass /deep/ .el-input__inner{
  padding: 0px 4px !important;
}

.typeRow{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
  border-bottom: 1px solid #E1E1E1;
  .typeIcon{
    font-size:40px;
  }
  .typeItem{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    /*margin-right: 50px;*/
    cursor: pointer;
    height: 82px;
    .typeText{
      font-size: 12px;
      color: #999999;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .activeTypeLine{
      width: 100%;
      height: 2px;
      background: transparent;
    }
  }
  .typeItem:hover{
    .newsTypeText{
      color: #333333;
    }
  }
  .typeItemActive{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    /*margin-right: 50px;*/
    cursor: pointer;
    height: 82px;
    .typeText{
      font-size: 12px;
      color: #333333;
      margin-top: 10px;
      margin-bottom: 10px;
    }
    .activeTypeLine{
      width: 100%;
      height: 2px;
      background: #FABE00;
    }
  }
}
.formDiv{
  border-radius: 0 0 4px 4px;
  margin-bottom: 30px;
}
.divContent{
  background: rgba(248,249,251,0.62);
}
.expandMoreBtn{
  margin-top: 12px;
  background: #E8E8E8;
  border: 1px solid #DFDFDF;
  border-radius: 2px;
  height: 25px;
  display: inline-block;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 10px;
  cursor:pointer;
  margin-bottom: 5px;
  .expandIcon{
    font-size: 12px;
  }
  .expandMoreText{
    display: inline;
    margin-left: 5px;
    font-size: 12px;
    color: #666666;
  }
}
.expandDiv{
  margin-bottom: 20px;
  .expandMoreDiv{
    margin: 0 14px;
    padding: 20px 10px 0px 10px;
    background: #F2F4F6;
    border-radius: 2px;
    position: relative;
  }
  .closeExpandBtn{
    position: absolute;
    right: 0px;
    top:0px;
    width: 24px;
    height: 24px;
    border-radius:2px;
    background: #D3D3D3;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    .closeIcon{
      font-size: 14px;
      color: #FFFFFF;
    }
  }

  .expandTitleRow{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 10px;
    margin-bottom: 5px;
    .circleYellow{
      width: 12px;
      height: 12px;
      background: #FABE00;
      border-radius: 50%;
      margin: 0 10px;
    }
    .expandTitle{
      font-size: 14px;
      color: #333333;
    }
  }
}
.labelText{
  font-size: 12px;
  color: #999999;
  margin-left: 4px;
}
.deleteBtn{
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
  .delIcon{
    font-size: 18px;
  }
}
.addBtn{
  width: 20px;
  height: 16px;
  border: 1px solid #FABE00;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 18px;
  .addIcon{
    font-size: 12px;
    color: #FABE00;
  }
}
.addCustomerBtn{
  background: #3B2E26;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 30px;
  .addIcon{
    color: #ffffff;
    font-size: 12px;
  }
}
.lease_info{
  display: flex;
  .lease_title{
    flex: 1;
    font-size: 14px;
    color: #333333;
    font-weight: bold;
  }
  position: relative;
  margin-bottom: 5px;
  background: rgba(248,249,251,0.62);
  padding: 10px 20px;
  .edit_icon{
    font-size: 18px;
  }
}
.ant-select-dropdown-content{
  /deep/.invisible-item{
    display:initial !important;
  }
}
/deep/.invisible-item{
  display:none;
}

</style>